var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gray-80" },
    [
      _c("div", { staticClass: "flex-row jc-space" }, [
        _c("div", { staticClass: "mb-1" }, [
          _c("span", { staticClass: "gray-100 fs-10 bold lh-32" }, [
            _vm._v(_vm._s(_vm.value))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "fs-3 lh-big" }, [
            _vm._v("/ " + _vm._s(_vm.total))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-1 self-end" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$l10n.n__(
                  "%d licence restante",
                  "%d licences restantes",
                  _vm.rest,
                  _vm.rest
                )
              ) +
              "\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("el-progress", {
        attrs: {
          "stroke-width": 4,
          percentage: _vm.progress,
          format: function() {},
          "text-inside": true,
          status: _vm.status
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }